// fake wizard object until wizard.js in regular client can be whittled down and used standalone aswell
import React from "react";
import {Modal} from "antd";
import JSONPretty from "react-json-pretty";
import {includes} from "lodash";

// pretend global object so we can mostly just cutnpaste code from MCC
let mccLogin, mccAuth;

export function Wizard({mccLogin: localMccLogin, mccAuth: localMccAuth}){
    mccLogin = localMccLogin;
    mccAuth = localMccAuth;
    this.adSellerLoginUrl = 'https://app.pulseresearch.com/a/focus/login/metrographics';
    this.adSellerReturnUrl =  null;
    this.isAdSeller = false;
    this.adSellerServices = ['Classified Dynamics','Holiday Adv. Service',
        'Metro Newspaper Service','Sales Spectaculars'];
}

Wizard.prototype ={
    getServices: function () {
        if (this.isAdSeller  && ! mccLogin.profile.USERTYPE === 'RelevanceProject') // Boost services only in the wizard
            return this.adSellerServices;

        // Holiday service includes use of wizard so restrict to just those ads
        // This doesn't make any sense & clashes with "Holiday only" anyway
        //if (_.contains(mccLogin.standardServices, 'Holiday Adv. Service')
        //        && ! _.contains(mccLogin.profile.SERVICENAME,'MiAD'))
        //    return 'Holiday Adv. Service';

        return mccLogin.standardServices;
    },
    importAdSeller: function importAdSeller(data)
    {
        this.adSeller = data;
        var formData = this.adSellerToFormData(data);
        docCookies.setItem('AdSeller', JSON.stringify(data));

        this.saveFormData(formData);
        this.populateForm(formData);

        if (data.return) {
            this.adSellerReturnUrl = data.return;
        }
        if (data.presentation){
            this.adSellerPresentation = data.presentation;
        }

        //if (this.useMobile) return;

/*
        if (mcc.aod_wizard){
            loadAodClient(true); // may not be loaded yet...
            window.aod_web_client.callbacks.loadAdSeller(data);
            clientView.push('aod_wizard',{lib:'Creative'});
        } else {
            var mode = 'container';
            if (data.presentation)
            {
                $('.adseller_select').show();

                if (data.presentation.ad_id)
                {
                    if (data.presentation.mode === 'previewOnly') {
                        mode = 'results';
                        $('.mode-previewOnly').show();
                        $('.mode-regular').hide();
                    }

                    this.getAsset(data.presentation.ad_id)
                        .then(_.bind(this.render,this))
                        .fail(function()
                        {
                            if (libs.current === 'wizard') {
                                displayMode.set('container');
                            }
                            toastr.warning('Spec Ad: '+data.presentation.ad_id+' not found');
                        });
                }
            }
            // more globals...
            if (libs.current === 'wizard') {
                displayMode.set(mode);
            }
        }
 */
    },

    adSellerToFormData: function(){},
    saveFormData: function(){},
    populateForm: function(){},

    assetAuth: function assetAuth(asset)  // (): true || denied message string
    {
        // Asset based permissions
        var permissions = mccAuth.getAssetPermissions(asset || this.asset);

        //if ( ! (_.contains(permissions,'MiAD')  || mccLogin.profile.ADSELLER === 'YES') )
        // todo Ad Seller should just use regular services?
        if ( ! (
            _.contains(permissions,'MiAD')
            || _.contains(mccLogin.profile.TAG, 'Ad Seller')
            || mccLogin.profile.USERTYPE === 'RelevanceProject'
        ) ) {
            return miadTrialConfig.getMessage;
        }

        if (this.trialEnd) {//Check services?
            if (this.trialEnd < new Date()) {
                return miadTrialConfig.expiredMessage.replace('<end>', this.trialEnd.toLocaleDateString());
            }
        }

        return true;
    },

    adSellerSelect: function(asset)
    {
        if (this.adSellerPresentation && asset) {
            this.adSellerPresentation.ad_id = asset.file_base ;
        }

        this.adSellerReturn();
    },

    adSellerReturn: function()
    {
        var self = this;

        mcg.getRemoteAuth()
            .then(function(auth)
            {
                var data = {
                    //advertiser: self.exportAdSellerAdvertiser(),
                    user: {
                        id: mccLogin.profile.PULSEID,
                        email: mccLogin.profile.EMAIL ||'',
                        name: mccLogin.profile.CN|| ''
                    },
                    auth: auth
                };

                if (self.adSeller && self.adSeller.advertiser) {
                    data.advertiser = self.adSeller.advertiser ;
                }

                if (self.adSellerReturnUrl) {
                    data.return = self.adSellerReturnUrl ;
                }

                if (self.adSellerPresentation) {
                    data.presentation = self.adSellerPresentation ;
                }

                postJsonInForm(self.adSellerLoginUrl, data);
            });

        //alert('Post to Ad Seller: ');
    },

    /*
    // we use our own search for now
    getAsset: function getAsset(adName)
    {
        var query = new mcc.Query();
        query.addFilter('metro_type',['spec ad']);
        query.addFilter('has_miad',['has miad']);
        query.addFilter('color',['color']);
        query.addFilter('file_ext',['qxd','qxp','psd','jpg']);
        query.addFilter('file_base',adName); // NOP for searching
        query.addFilter('service', this.getServices() );

        _.each(this.filter,function(value,key){
            query.addFilter(key,value);
        });
        _.each(this.notFilter,function(value,key){
            query.addNotFilter(key,value);
        });

        //TBD declare own insatnce of search
        search.wizard = new mcc.Search('wizard',query);

        //search.wizard.execute(this.getStart(),this.batchSize,this.order)
        return search.wizard.execute(1,1,'latest')
            .pipe(function(results)
            {
                return results.total ?
                    results.records[0] : // an MCC Asset
                    $.Deferred().reject();
            });
    },
     */
};

// more fake globals...

const mcg = {
    getRemoteAuth: async ()=>({
        "time": "1591994354",
        "token": "24996e2de1c667d0bdbe9c4f0a21f75fcf2ef034"
    })
}

const postJsonInForm = (url, data) => {
    Modal.info({title:url, content: <JSONPretty data={data}/>});
}

const miadTrialConfig = {
    // NOTE email address must be broken up to avoid the CMS munging it
    getMessage: "To access this valuable feature, current subscribers can contact Customer Service at 800.223.1600 or email "
        + '<a href="mailto:service@metro-email.com?Subject=MiAD%20Trial">service@metro-email.com</a> '
        + "(M-F, 8:45am - 5:45pm EST) for their User IDs and Passwords. Non-subscribers can contact Customer Service to register for a free 30-day trial." ,
    // Use <end> to indicate where the end date should go
    expiredMessage: "Your MiAD trial ended on <end> . To upgrade your subscription call us at 800.223.1600 or email "
        + '<a href="mailto:service@metro-email.com?Subject=MiAD%20Trial">service@metro-email.com</a> '
        + "(M-F, 8:45am - 5:45pm EST)."
};

const _ = {
    contains: (...args) => includes(...args)
}

const docCookies = {
    setItem: ()=>{}
}